import React, { useEffect, useState, useContext } from "react";

import {
  Box,
  Card,
  Grid,
  TablePagination,
  Typography,
  Stack,
  CircularProgress,
  Button,
  ClickAwayListener,
  Tooltip,
  styled,} from "@mui/material";
import { fraudEventsDataKeysAndRepr, fraudEventsSummaryCard } from "./data";
import SimpleCard from "pages/dashboard/shared/SimpleCard";
import Table from "components/table/Table";
import { MERCHANT_RAISED_DISPUTE_TABLE_MENU } from "utils/constant";
import useMenu from "hooks/useMenu";
import {
  fetchDisputeStats,
  fetchMerchantraisedDisputeStats,
  getMerchantRaisedDisputeList,
} from "services/https/disputeService";
import * as _ from "lodash";
import { TextToLabel } from "utils/textToLabel";
import { useNavigate } from "react-router-dom";
import AuthContext from "contexts/JWTAuthContext";
import { userHasPermission } from "utils/utilFn";
import { useDispatch } from "react-redux";
import { useOutletContext } from "react-router-dom";
import { createDialog } from "redux/actions/AlertActions";
import { FraudEventsFilterForm } from "pages/logs/pages/FraudManagement/fraudEventsFilterForm";
import AddIcon from "@mui/icons-material/Add";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { CSVLink } from "react-csv";


const defaultFilters = {
  disputeStatus: "",
  adminStatus: "",
  merchantStatus: "",
  resolution: "",
  startDate: "",
  endDate: "",
};

const FraudEventsList = () => {
  const { setTableMenu } = useMenu();
  const [stats, setStats] = useState({});
  const [statsLoading, setStatsLoading] = useState(false);
  const [pageData, setPageData] = useState();
  const [data, setData] = useState({ content: [] });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isLoading, setLoading] = useState(false);
  const [filters, setFilters] = useState(defaultFilters);
  const [open, setOpen] = useState(false);
  const { userPermissions } = useContext(AuthContext);
  const showManaging = userHasPermission(userPermissions, "MANAGE_DISPUTES");

  const navigate = useNavigate();
  const destructureNeed = (data = []) => {
    const objArray = data.map((contentData) => {
      const {
        disputeType,
        disputeAmount,
        transactionDate,
        dateCreated,
        disputeStatus,
        merchantComplaintId,
        merchantEmail,
      } = contentData;
      return {
        disputeStatus: TextToLabel(disputeStatus),
        disputeType,
        disputeAmount: `NGN${disputeAmount ?? "N/A"} on ${
          transactionDate ?? "N/A"
        }`,
        dateCreated,
        merchantEmail,
        id: merchantComplaintId,
      };
    });
    setData({ content: objArray });
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const StyledHeadSearch = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
  }));

  useEffect(() => {
    setTableMenu(MERCHANT_RAISED_DISPUTE_TABLE_MENU);
    setStatsLoading(true);
  
    fetchMerchantraisedDisputeStats()
      .then((data) => {
        if (!_.isEmpty(data)) {
          setStats({
            initiatedDispute: data?.totalCount ?? 0,
            openDispute: data?.openCount ?? 0,
            closedDispute: data?.resolvedCount ?? 0,
          });
        } else {
          // empty response fallback
          setStats({
            initiatedDispute: 0,
            openDispute: 0,
            closedDispute: 0,
          });
        }
      })
      .catch(() => {
        // error fallback
        setStats({
          initiatedDispute: 0,
          openDispute: 0,
          closedDispute: 0,
        });
      })
      .finally(() => setStatsLoading(false));
  }, []);

 

  useEffect(() => {
    setLoading(true);
  
    getMerchantRaisedDisputeList({
      page,
      size: rowsPerPage,
      ...filters,
    })
      .then((res) => {
        setLoading(false);
        setPageData(res);
        destructureNeed(res);
      })
      .catch(() => setLoading(false));
  }, [page, rowsPerPage, filters]);

  const handleExport = async () => {
    try {
      const res = await getMerchantRaisedDisputeList({
        ...filters,
        export: true, // or size: large number if backend supports
      });
  
      const formatted = res.map((item) => ({
        disputeStatus: item.disputeStatus,
        disputeType: item.disputeType,
        disputeAmount: item.disputeAmount,
        dateCreated: item.dateCreated,
        merchantEmail: item.merchantEmail,
      }));
  
      // trigger download manually
      const csvData = formatted;
  
      const link = document.createElement("a");
      link.href =
        "data:text/csv;charset=utf-8," +
        encodeURIComponent(
          [
            Object.keys(csvData[0]).join(","),
            ...csvData.map((row) => Object.values(row).join(",")),
          ].join("\n")
        );
  
      link.download = "dispute.csv";
      link.click();
    } catch (err) {
      console.error("Export failed", err);
    }
  };

  const handleRowClick = (id) => {
    console.log("checking id", id);
    navigate(`/logs/dispute/merchant/resolution/${id}`, {
      state: { details: true },
    });
  };

  const dispatch = useDispatch();
  const handleBtnClick = (e, type) => {
    dispatch(createDialog({ type }));
    // setOpenDialog(true);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const handleTooltipClose = () => {
    setOpen(false);
  };
    
  const getStatValue = (key) => {
    if (statsLoading) return <CircularProgress size={12} />;
    return stats?.[key] ?? 0;
  };

  return (
    <>
      <StyledHeadSearch>
      <Stack direction={"row"}>
        <ClickAwayListener onClickAway={handleTooltipClose}>
          <div>
            <Tooltip
              PopperProps={{
                disablePortal: true,
              }}
              onClose={handleTooltipClose}
              open={open}
              disableFocusListener
              disableHoverListener
              disableTouchListener
                // title={<FilterForm close={handleTooltipClose} />}
                title={
                  <FraudEventsFilterForm
                    values={filters}
                    onChange={setFilters}
                    onApply={() => setPage(0)}
                    onClear={() => setFilters(defaultFilters)}
                    close={handleTooltipClose}
                  />
                }
              arrow
            >
              <Button
                onClick={handleTooltipOpen}
                startIcon={<FilterAltIcon />}
                sx={{ mr: 4 }}
              >
                {"Filter"}
              </Button>
            </Tooltip>
          </div>
        </ClickAwayListener>
      </Stack>
      <Stack direction="row" spacing={2}>
        <Button variant="contained" onClick={handleExport}>
        <CSVLink data={data?.content || []} filename={"dispute.csv"}>
            {"Export"}
          </CSVLink>
        </Button>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={(e) => handleBtnClick(e, "createMerchantDispute")}
          sx={{display: showManaging ? 'flex' : 'none' }}
        >
          {"Create New Dispute"}
        </Button>
      </Stack>
    </StyledHeadSearch>

      <Box
        sx={{
          mb: 3,
          overflowX: "auto",
        }}
      >
        <Stack
          direction="row"
          spacing={2}
          sx={{
            minWidth: "600px",
            pb: 1
          }}
        >
          {fraudEventsSummaryCard.map(({ title, objKeyRepr }) => (
            <Box key={`${objKeyRepr}`} sx={{ minWidth: 160 }}>
              <SimpleCard
                title={title}
                width="100%"
                height="120px"
              >
                      <Typography variant="h6">
                          {getStatValue(objKeyRepr)}
                      </Typography>
              </SimpleCard>
            </Box>
          ))}
        </Stack>
      </Box>

      <Table
        dataKeysAndRepr= {showManaging ? fraudEventsDataKeysAndRepr : fraudEventsDataKeysAndRepr.filter(item => item?.objKey !== 'action')}
        // dataKeysAndRepr={wayaMerchantDataKeysAndRepr}
        dataItemRows={data?.content}
        pageData={pageData}
        alignAction={"center"}
        isLoading={isLoading}
        handleRowClick={handleRowClick}
      />

      <TablePagination
        component="div"
        // count={data?.content?.length}
        count={pageData?.totalElements || 0}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
      />
    </>
  );
};

export default FraudEventsList;